import React from 'react';
import { Link } from 'react-router-dom';
import dateFormat from 'utils/date_format';

const UserSearchResult = ({ item = {} }) => (
  <tr>
    <td>{item.id}</td>
    <td><Link to={`/users/${item.id}`}>{item.name}</Link></td>
    <td>{item.email}</td>
    <td>{dateFormat(item.created_at)}</td>
  </tr>
);

export default UserSearchResult;
